export default __webpack_public_path__ + "static/media/backgroundImageContacts.cca36690.gif";